import type { InjectionKey } from 'vue';
import type { BookingModeFunc, UpdateFinishButtonFunc } from '../types/order-main';

export const UpdateBookingModeKey: InjectionKey<BookingModeFunc> = Symbol('orderMain.updateBookingMode');
export const UpdateFinishButtonKey: InjectionKey<UpdateFinishButtonFunc> = Symbol('orderMain.updateFinishButton');

export default {
  UpdateBookingModeKey,
  UpdateFinishButtonKey,
};
